// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__A8Rsg","employee-header-item":"Header_employee-header-item__4ZErk"};